export const FUEL = ["Diesel", "Electric", "Gasoline", "Hybrid"];
